import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { oneOf } from 'prop-types';

import { operators } from 'common/store/search/advanced/constraint';

const messages = defineMessages({
  empty: {
    id: 'search.advanced.criteria.operator.empty',
    defaultMessage: 'is empty',
  },
  notEmpty: {
    id: 'search.advanced.criteria.operator.notEmpty',
    defaultMessage: 'not empty',
  },
  equals: {
    id: 'search.advanced.criteria.operator.equals',
    defaultMessage: 'equals',
  },
  notEquals: {
    id: 'search.advanced.criteria.operator.notEquals',
    defaultMessage: 'not equals',
  },
  lessThan: {
    id: 'search.advanced.criteria.operator.lessThan',
    defaultMessage: 'less than',
  },
  greterThan: {
    id: 'search.advanced.criteria.operator.greterThan',
    defaultMessage: 'greater than',
  },
  between: {
    id: 'search.advanced.criteria.operator.between',
    defaultMessage: 'between',
  },
  within: {
    id: 'search.advanced.criteria.operator.within',
    defaultMessage: 'within',
  },
});

export const {
  EMPTY,
  NOT_EMPTY,
  EQUALS,
  NOT_EQUALS,
  LESS_THAN,
  GREATER_THAN,
  BETWEEN,
  WITHIN,
} = operators;

export const operatorShape = oneOf([
  EMPTY,
  NOT_EMPTY,
  EQUALS,
  NOT_EQUALS,
  LESS_THAN,
  GREATER_THAN,
  BETWEEN,
  WITHIN,
]);

export const translateOperator = operator => ({
  [EMPTY]: <FormattedMessage {...messages.empty} />,
  [NOT_EMPTY]: <FormattedMessage {...messages.notEmpty} />,
  [EQUALS]: <FormattedMessage {...messages.equals} />,
  [NOT_EQUALS]: <FormattedMessage {...messages.notEquals} />,
  [LESS_THAN]: <FormattedMessage {...messages.lessThan} />,
  [GREATER_THAN]: <FormattedMessage {...messages.greterThan} />,
  [BETWEEN]: <FormattedMessage {...messages.between} />,
  [WITHIN]: <FormattedMessage {...messages.within} />,
})[operator];
